var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 40,
    viewBox: "0 0 46 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23 32.8c-1.56 0-2.825-1.255-2.825-2.8s1.266-2.8 2.825-2.8c1.56 0 2.825 1.255 2.825 2.8-.098 1.545-1.364 2.8-2.825 2.8zm-2.018-18.628C20.982 12.944 21.86 12 23 12c1.14 0 2.018.944 2.018 2.172v9.161c0 1.228-.878 2.267-2.018 2.267-1.14 0-2.018-1.039-2.018-2.267v-9.16zm24.257 17.62L27.765 2.642C26.721.943 25.012 0 23.017 0c-1.994 0-3.702.943-4.748 2.642L.796 31.792C-.25 33.491-.25 35.566.7 37.264 1.65 39.057 3.455 40 5.545 40H40.49c1.995 0 3.799-1.038 4.843-2.736.95-1.698.855-3.773-.094-5.472z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.5abbb124.svg";
export { ForwardRef as ReactComponent };